import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import './ProductFormPage.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { X } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { getDiscountValidationError } from './productPricingValidation';
import {
    resolveBrandName,
    matchCategoryOption,
    matchBrandOption,
    preserveSelectOption,
} from './productSelectUtils';
import Swal from 'sweetalert2';
import AIProductAssistant from './AIProductAssistant';
import ProductSeoFields from './ProductSeoFields';
import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";

import {
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}

const calculateSalePrice = (data) => {

    const mrp = Number(data.originalPrice) || 0;

    let salePrice = 0;

    if (data.discount_type === "price") {
        const discount = Number(data.discount_price) || 0;
        salePrice = mrp - discount;
    }

    if (data.discount_type === "percentage") {
        const discount = Number(data.discount_percentage) || 0;
        salePrice = mrp - (mrp * discount) / 100;
    }

    if (salePrice < 0) salePrice = 0;

    return salePrice.toFixed(2);
};

function SortableKeyFeature({ feature, setFormData }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: feature.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="oms-tag-item"
    >
      {feature.text}

      <X
        type="button"
        className="oms-tag-delete"
        onClick={() => {
          setFormData(prev => ({
            ...prev,
            key_features: prev.key_features.filter(
              f => f.id !== feature.id
            )
          }));
        }}
        size={14}
      />
    </li>
  );
}

const SimpleProductEdit = () => {
    const { id } = useParams()
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    console.log(user)
    if (user) {
        console.log("✅ User:", user);
    } else {
        console.log("⚠️ User not found or decryption failed.");
    }
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        originalPrice: '',
        discountPrice: '',
        product_type: { value: 'Simple Product', label: 'Simple Product' },
        category: null,
        totalStock: '',
        stock: '',
        status: null,
        typeofsimple: "virtual",
        categorytype: "",
        short_description: "",
        description: "",
        // grouped_products: [],
        product_url: "",
        button_text: "",
        stock: "",
        download_limit: null,
        download_expiry: null,
        downloadable_files: [],
        sku: "",
        weight: "",
        length: "",
        width: "",
        height: "",
        user_id: "",
        user_name: "",
        delivery_days: "",
        key_features: [],
        specifications: [],
        category_id: "",
        categorytype_id: [],
        warranty: "Yes",
        warranty_from: "",
        warranty_note: "",
        brand_name: "",
        installation: "",
        installation_fee: "",
        brand_id: [],
        gst_type: "included",
        gst_percentage: "",
        hsn: "",
        discount_type: "price",
        discount_price: "",
        discount_percentage: "",
    });
    const [brand, setBrand] = useState([]);

    console.log(formData)
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const [categories, setCategories] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const url = API_BASE_URL;
    const [loading, setLoading] = useState(false);

    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            const options = res.map(cat => ({
                value: cat.category || cat.category || cat.id,
                label: cat.category || cat.category || cat.category,
                id: cat.id
            }));
            setCategories(options);
        } catch (error) {
            console.error(error)
        }
    }

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${url}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();

            const options = res.data.map(cat => ({
                value: cat.id,
                label: cat.name || cat.name || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top


            setBrand(options);
        } catch (error) {
            console.error(error);
        }
    };




    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const navigate = useNavigate();
    const [productSingle, setProductSingle] = useState({});
    const [productRaw, setProductRaw] = useState(null);
    const productHydratedRef = useRef(false);
    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };


    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }


    const updateTypeofSimple = (key, isChecked) => {
        let updatedTypes = formData.typeofsimple.split(',').filter(Boolean);

        if (key === 'virtual' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['virtual'];
        } else if (key === 'downloadable' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['downloadable'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            typeofsimple: updatedTypes.join(',')
        }));
    };

    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = (formData.categorytype || "").split(',').filter(Boolean);


        if (key === 'Best Sellers' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['Best Sellers'];
        } else if (key === 'Trending' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['Trending'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes.join(',')
        }));
    };


    const updateTypeofWar = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty: updatedTypes.join(','),
        }));
    };


    const updateTypeofWarfrom = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty_from: updatedTypes.join(','),
        }));
    };

    const updateTypeofInstall = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            installation: updatedTypes,
        }));
    };


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };

    const handleSelectChangeBrand = (selectedOption, { name }) => {

        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,               // keep label+value for UI
            brand_id: selectedOption?.value || "", // keep value for backend
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const discountError = getDiscountValidationError(formData, formData.originalPrice, {
            baseLabel: "MRP",
        });
        if (discountError) {
            toast.warning(discountError, {
                position: "top-center",
                autoClose: 2000,
            });
            setLoading(false);
            return;
        }
        if (formData.title === "" || formData.title === null) {
            toast.warning("Add Product Title", {
                position: "top-center",
                autoClose: 2000
            })
            return;
        }
        try {
            const payload = {
                ...formData,
                warranty: Array.isArray(formData.warranty)
                    ? formData.warranty[0] || ""
                    : formData.warranty,

                warranty_from: Array.isArray(formData.warranty_from)
                    ? formData.warranty_from[0] || ""
                    : formData.warranty_from,

                installation: Array.isArray(formData.installation)
                    ? formData.installation[0] || ""
                    : formData.installation,
                image: typeof formData.image[0] === 'string'
                    ? formData.image[0]
                    : formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                categorytype: formData.categorytype || "", // Already a string
                category: formData.category?.value || "",
                user_id: user.main_id,
                user_name: user.full_name,
                brand_name: resolveBrandName(formData.brand_name),
                // warranty_from: formData.warranty_from || "",
                // installation: formData?.installation[0] || "",
                gst_type: formData.gst_type,
                gst_percentage: formData.gst_type === "excluded" ? formData.gst_percentage : null,
            };

            const response = await fetch(`${url}/simple-product/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product Updated successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
                console.log("Product submitted successfully");
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
                setLoading(false)
            }

        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setLoading(false)
        }
    };


    const handleImageSelect = (imgs) => {
        const isValidImage = (file) => {
            const url = file?.url || file;
            const fileName = typeof url === 'string' ? url : '';
            const extension = fileName.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'webp'].includes(extension);
        };

        const invalidFiles = Array.isArray(imgs) ? imgs.filter(img => !isValidImage(img)) : [imgs].filter(img => !isValidImage(img));

        if (invalidFiles.length > 0) {
            alert("Only image files (JPG, PNG, WEBP) are allowed.");
            return;
        }


        setFormData((prev) => ({
            ...prev,
            gallery: Array.isArray(imgs)
                ? [...prev.gallery, ...imgs]
                : [...prev.gallery, imgs]
        }));
    };


    const handleSingleImageSelect = (img) => {
        const url = img?.url || img;
        const fileName = typeof url === 'string' ? url : '';
        const extension = fileName.split('.').pop().toLowerCase();

        const validExtensions = ['jpg', 'jpeg', 'png', 'webp'];

        if (!validExtensions.includes(extension)) {
            toast.success("Only image files (JPG, PNG, JPEG, WEBP) are allowed.");
            return;
        }

        // Valid image – set image
        setFormData((prev) => ({
            ...prev,
            image: [img]
        }));
    };



    const handleNavigate = (url) => {
        navigate(url)
    };


    useEffect(() => {
        if (!id) return;
        productHydratedRef.current = false;
        setProductRaw(null);

        const fetchSingleProduct = async () => {
            try {
                const response = await axios.get(`${url}/grouped-product/single/${id}`);
                setProductRaw(response.data);
            } catch (error) {
                console.error("Error fetching product:", error);
                toast.error("Failed to fetch product data");
            }
        };

        fetchSingleProduct();
    }, [id]);

    useEffect(() => {
        if (!productRaw) return;

        const safeParse = (value) => {
            try {
                return typeof value === "string" ? JSON.parse(value) : value || [];
            } catch (e) {
                return [];
            }
        };

        const matchedCategory = matchCategoryOption(categories, productRaw);
        const matchedBrand = matchBrandOption(brand, productRaw);

        if (!productHydratedRef.current) {
            productHydratedRef.current = true;
            setFormData({
                ...productRaw,
                product_type: { label: productRaw.product_type, value: productRaw.product_type },
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                key_features: safeParse(productRaw.key_features).map(f => ({
                    id: f?.id || crypto.randomUUID(),
                    text: f?.text || f
                })),
                specifications: safeParse(productRaw.specifications).map(spec => ({
                    ...spec,
                    id: spec.id || crypto.randomUUID()
                })),
                downloadable_files: safeParse(productRaw.downloadable_files),
            });

            setProductSingle({
                ...productRaw,
                product_type: productRaw.product_type,
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                attribute: safeParse(productRaw.attribute),
                variation: safeParse(productRaw.variation),
                key_features: safeParse(productRaw.key_features),
                specifications: safeParse(productRaw.specifications),
                brand_id: safeParse(productRaw.brand_id)
            });
            return;
        }

        setFormData((prev) => ({
            ...prev,
            category: preserveSelectOption(prev.category, matchedCategory),
            brand_name: preserveSelectOption(prev.brand_name, matchedBrand),
            category_id: prev.category_id || productRaw.category_id || "",
        }));
    }, [productRaw, categories, brand]);


    const handleCopy = async () => {
        try {
            const confirm = await Swal.fire({
                title: 'Copy Product ?',
                text: `Duplicate "${productSingle.title}" ?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, Copy",
            });

            if (!confirm.isConfirmed) return;

            const res = await axios.post(`${url}/grouped-product/copy-product/${productSingle.product_id}`,
                { user_id: user.main_id },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }

            )
            toast.success("Product copied!");
            navigate(`/simple-productedit/${res.data.newProduct.product_id}`);

        } catch (error) {
            toast.error("Copy failed")
        }
    }


    console.log(brand, categories)


    useEffect(() => {
        handleImageView();
        fetchCategories();
        fetchBrand();
    }, [])

    return (
        <>

            <div className="product-form-page">
                <div className="oms-header product-form-page__header">
                    <div className="product-form-page__title-wrap">
                        <h1 className="dashboard-title">Simple Product</h1>
                        <p className="product-form-page__subtitle">
                            Update the fields below—pricing and stock changes apply to your storefront when you save.
                        </p>
                    </div>
                    <div className="product-form-page__header-actions">
                        <button type="button" className="omsnewbutton-copy" onClick={handleCopy}>
                            Duplicate
                        </button>
                        {
                            loading ? (
                                <button type="button" className="oms-add-btn">
                                    Updating...
                                </button>
                            ) : (
                                <button type="button" onClick={handleSubmit} className="oms-add-btn">
                                    Update
                                </button>
                            )
                        }
                    </div>
                </div>
                <form className="oms-modal-form property-form product-form-page__form" onSubmit={handleSubmit}>
                    <div className='oms-givepaddingfrom'>
                        {/* <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                onChange={handleSelectChange}
                                isDisabled
                            />
                        </div> */}

                        {
                            formData.product_type.value === "Simple Product" && (
                                <div className="oms-form-group">
                                    <label className="oms-form-label">Choose Type</label>
                                    <div className="oms-checkbox-group">
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="virtual"
                                                checked={formData.typeofsimple.includes("virtual")}
                                                onChange={(e) => updateTypeofSimple("virtual", e.target.checked)}
                                            />
                                            <label htmlFor="virtual">Virtual</label>
                                        </div>
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="downloadable"
                                                checked={formData.typeofsimple.includes("downloadable")}
                                                onChange={(e) => updateTypeofSimple("downloadable", e.target.checked)}
                                            />

                                            <label htmlFor="downloadable">Downloadable</label>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        <AIProductAssistant
                            productType="simple"
                            onApply={(patch) =>
                                setFormData((prev) => ({ ...prev, ...patch }))
                            }
                        />

                        {/* Title */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Product Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                name='title'
                                placeholder="Enter product name"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter a brief summary for quick view"
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Product Description
                            </label>
                            <div className="product-form-page__quill">
                                <ReactQuill
                                    theme="snow"
                                    value={formData.description}
                                    onChange={(value) =>
                                        setFormData((prev) => ({ ...prev, description: value }))
                                    }
                                    placeholder="Enter a detailed product description"
                                />
                            </div>
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Main Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Product Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : `${url}${formData.image[0]}`}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}
                                    >
                                        <i className="fa-solid fa-xmark" aria-hidden />
                                    </p>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            // onImageSelect={handleSingleImageSelect}
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Additional Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} className="product-form-page__gallery-item">
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className="gallery-preview-image"
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}
                                        >
                                            <i className="fa-solid fa-xmark" aria-hidden />
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery} // 🔁 separate state
                            handleClose={() => setShowImageModalGallery(false)}
                            selectedGalleryImages={formData.gallery}
                            images={images}
                            multiple={true}
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        // onImageSelect={(imgs) => handleImageSelect(imgs)}
                        />



                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <div className="oms-form-group">
                                    <label htmlFor="status" className="oms-form-label">
                                        Downloadable files
                                    </label>
                                    <DownloadableFiles downloadable_files={formData.downloadable_files} setFormData={setFormData} />
                                </div> : null
                        }
                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <>
                                    <div className="oms-form-group">
                                        <label htmlFor="download_limit" className="oms-form-label">
                                            Download Limit
                                        </label>
                                        <input
                                            type="number"
                                            id="download_limit"
                                            name='download_limit'
                                            placeholder="Unlimited"
                                            value={formData.download_limit}
                                            onChange={handleChange1}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="download_expiry" className="oms-form-label">
                                            Download Expiry
                                        </label>
                                        <input
                                            type="number"
                                            id="download_expiry"
                                            name='download_expiry'
                                            placeholder="Enter the number of days before a download link expires, or leave blank."
                                            value={formData.download_expiry}
                                            onChange={handleChange1}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                </>
                                : null
                        }


                        {/* Original Price */}
                        <div className="oms-form-group">
                            <label htmlFor="originalPrice" className="oms-form-label">
                                MRP (Original Price)
                            </label>
                            <input
                                type="number"
                                id="originalPrice"
                                placeholder="Enter MRP before discount"
                                value={formData.originalPrice}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Discount Type</label>

                            <div className="oms-checkbox-group">

                                {/* Price */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="discount_price"
                                        name="discount_type"
                                        checked={formData.discount_type === "price"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                discount_type: "price",
                                                discount_percentage: ""
                                            }))
                                        }
                                    />
                                    <label htmlFor="discount_price">Price</label>
                                </div>

                                {/* Percentage */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="discount_percentage"
                                        name="discount_type"
                                        checked={formData.discount_type === "percentage"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                discount_type: "percentage",
                                                discount_price: ""
                                            }))
                                        }
                                    />
                                    <label htmlFor="discount_percentage">Percentage</label>
                                </div>

                            </div>
                        </div>
                        {formData.discount_type === "price" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">Discount Price</label>
                                <input
                                    type="number"
                                    placeholder="Enter discount price"
                                    value={formData.discount_price}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        setFormData(prev => {
                                            const updated = {
                                                ...prev,
                                                discount_price: value,
                                                discount_percentage: ""
                                            };

                                            updated.discountPrice = calculateSalePrice(updated);

                                            return updated;
                                        });
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        {formData.discount_type === "percentage" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">Discount Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter discount percentage"
                                    value={formData.discount_percentage}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        setFormData(prev => {
                                            const updated = {
                                                ...prev,
                                                discount_percentage: value,
                                                discount_price: ""
                                            };

                                            updated.discountPrice = calculateSalePrice(updated);

                                            return updated;
                                        });
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}

                        {/* Discount Price */}
                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Sale Price
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter discounted selling price"
                                value={formData.discountPrice}
                                onChange={handleChange1}
                                readOnly
                                onWheel={(e) => e.target.blur()}
                            />

                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                SKU Code
                            </label>
                            <input
                                type="text"
                                id="sku"
                                placeholder="Enter Stock Keeping Unit (SKU)"
                                value={formData.sku}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Stock status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select stock availability"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}

                            />
                        </div>

                        {
                            formData.stock.value === "Unlimited Stock" ? null :
                                <div className="oms-form-group">
                                    <label htmlFor="totalStock" className="oms-form-label">
                                        Total Stock
                                    </label>
                                    <input
                                        type="number"
                                        id="totalStock"
                                        placeholder="Enter available quantity"
                                        value={formData.totalStock}
                                        onChange={handleChange1}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                        }

                        <div className="oms-form-group">
                            <label htmlFor="weight" className="oms-form-label">
                                Product Weight
                            </label>
                            <input
                                type="number"
                                id="weight"
                                placeholder="Enter Weight"
                                value={formData.weight}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label className="oms-form-label">Dimensions (cm)</label>
                            <div className="oms-dimensions-row">
                                <input
                                    type="number"
                                    placeholder="Length"
                                    value={formData.length}
                                    onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <input
                                    type="number"
                                    placeholder="Width"
                                    value={formData.width}
                                    onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <input
                                    type="number"
                                    placeholder="Height"
                                    value={formData.height}
                                    onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        </div>
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div className="product-form-page__field-row">
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter main highlights/features"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: [
                                                    ...prev.key_features,
                                                    {
                                                        id: crypto.randomUUID(),
                                                        text: keyFeatureInput.trim()
                                                    }
                                                ]
                                            }));
                                            setKeyFeatureInput('');
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {

                                        const oldIndex = formData.key_features.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.key_features.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.key_features,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            key_features: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.key_features || []).map(f => f.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.key_features || []).map(feature => (
                                            <SortableKeyFeature
                                                key={feature.id}
                                                feature={feature}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Product Specifications</label>
                            <div className="product-form-page__spec-tools">
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Add specification label (Max 25 Characters)"
                                    value={specInput.label}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 25) {
                                            setSpecInput((prev) => ({ ...prev, label: e.target.value }));
                                        }
                                    }}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Add specification value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: [
                                                    ...prev.specifications,
                                                    { ...specInput, id: crypto.randomUUID() }
                                                ],
                                            }));
                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>

                            {/* <ul className="oms-tag-list">
                                {(formData?.specifications || []).map((spec, index) => (
                                    <li key={index} className="oms-tag-item">
                                        <strong>{spec.label}:</strong> {spec.value}
                                        <X
                                            type="button"
                                            className="oms-tag-delete"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    specifications: prev.specifications.filter((_, i) => i !== index),
                                                }));
                                            }}
                                            size={14}
                                        />
                                    </li>
                                ))}
                            </ul> */}
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {
                                        const oldIndex = formData.specifications.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.specifications.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.specifications,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            specifications: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.specifications || []).map(item => item.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.specifications || []).map((spec, index) => (
                                            <SortableSpecification
                                                key={spec.id}
                                                spec={spec}
                                                index={index}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        <ProductSeoFields formData={formData} setFormData={setFormData} />

                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select a category for this product"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="brand_name" className="oms-form-label">
                                Brand
                            </label>
                            <Select
                                options={brand}
                                placeholder="Select brand"
                                name="brand_name"
                                value={formData.brand_name}
                                onChange={handleSelectChangeBrand}
                                isClearable
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Yes"
                                        checked={formData?.warranty?.includes("Yes")}
                                        onChange={(e) => updateTypeofWar("Yes", e.target.checked)}
                                    />
                                    <label htmlFor="Yes">Yes</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="No"
                                        checked={formData?.warranty?.includes("No")}
                                        onChange={(e) => updateTypeofWar("No", e.target.checked)}
                                    />

                                    <label htmlFor="No">No</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty From</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Us"
                                        checked={formData?.warranty_from?.includes("Us")}
                                        onChange={(e) => updateTypeofWarfrom("Us", e.target.checked)}
                                    />
                                    <label htmlFor="Us">Us</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Company"
                                        checked={formData?.warranty_from?.includes("Company")}
                                        onChange={(e) => updateTypeofWarfrom("Company", e.target.checked)}
                                    />

                                    <label htmlFor="Company">Company</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="warranty_note" className="oms-form-label">
                                Warranty note
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.warranty_note}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, warranty_note: value }))
                                }
                                placeholder="Enter Warranty Note"
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Time (Days)
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter estimated delivery time"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Home Display Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype?.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype?.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Installation</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Free Installation"
                                        checked={formData.installation?.includes("Free Installation")}
                                        onChange={(e) => updateTypeofInstall("Free Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Free Installation">Free Installation</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Paid Installation"
                                        checked={formData.installation?.includes("Paid Installation")}
                                        onChange={(e) => updateTypeofInstall("Paid Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Paid Installation">Paid Installation</label>
                                </div>
                            </div>
                        </div>

                        {
                            formData?.installation && formData?.installation[0] === "Paid Installation" &&
                            <div className="oms-form-group">
                                <label htmlFor="installation_fee" className="oms-form-label">
                                    Installation Fee
                                </label>
                                <input
                                    type="number"
                                    id="installation_fee"
                                    placeholder="Enter Installation Fee"
                                    value={formData.installation_fee}
                                    onChange={handleChange1}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        }

                        <div className="oms-form-group">
                            <label className="oms-form-label">GST Type</label>

                            <div className="oms-checkbox-group">
                                {/* Included GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_included"
                                        name="gst_type"
                                        checked={formData.gst_type === "included"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "included",
                                                gst_percentage: "" // clear gst %
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_included">Included GST</label>
                                </div>

                                {/* Excluded GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_excluded"
                                        name="gst_type"
                                        checked={formData.gst_type === "excluded"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "excluded"
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_excluded">Excluded GST</label>
                                </div>
                            </div>
                        </div>

                        {/* GST Percentage - show only when excluded */}
                        {formData.gst_type === "excluded" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">GST Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter GST percentage e.g. 18"
                                    value={formData.gst_percentage}
                                    onChange={(e) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            gst_percentage: e.target.value
                                        }))
                                    }
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        <div className="oms-form-group">
                            <label htmlFor="hsn" className="oms-form-label">
                                HSN CODE
                            </label>
                            <input
                                type="text"
                                id="hsn"
                                placeholder="Enter HSN CODE"
                                value={formData.hsn}
                                onChange={handleChange1}
                            />
                        </div>
                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Product Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select visibility status (Active/Draft)"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {/* Actions */}


                        <div className="oms-form-actions">
                            {
                                loading ? <button type="button" className='post-property-submit'>Updating...</button> :
                                    <button type="submit" className='post-property-submit'>Update</button>
                            }

                        </div>
                    </div>

                </form >
            </div >
        </>
    );
};

export default SimpleProductEdit;


const DownloadableFiles = ({ downloadable_files, setFormData }) => {
    const [files, setFiles] = useState(downloadable_files || []);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const url = API_BASE_URL
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    const handleAddFile = () => {
        const updatedFiles = [...files, { name: '', url: '', file: null }];
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }

    useEffect(() => {
        handleImageView();
    }, [])

    return (
        <div className="downloadable-section">
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="File name"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="http://"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose file
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <ImageModalDownloadable
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) => {
                                const updatedFiles = [...files];
                                updatedFiles[index].url = `${url}${img.url}`; // ⬅️ Store full server URL here
                                setFiles(updatedFiles);
                                setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
                            }}
                            multiple={false}
                            setImages={setImages}
                        />

                    </div>
                ))}
                <button className="add-btn" type="button" onClick={handleAddFile}>
                    Add File
                </button>
            </div>
        </div>
    );
};


function SortableSpecification({ spec, index, setFormData }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: spec.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <li
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="oms-tag-item"
        >
            <strong>{spec.label}:</strong> {spec.value}

            <X
                type="button"
                className="oms-tag-delete"
                onClick={() => {
                    setFormData(prev => ({
                        ...prev,
                        specifications: prev.specifications.filter(
                            s => s.id !== spec.id
                        )
                    }));
                }}
                size={14}
            />
        </li>
    );
}